import React, { useState } from "react";
// import Modal from "react-modal";
import { Star } from '@mui/icons-material'
import { Link, useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
// import profile_icon from "../../assets/img/profile_icon.png";
import profile_icon from "../../assets/img/user.png";
import NannyProfileDisplay from "../profile/NannyProfileDisplay";

// Modal.setAppElement("#root");

// bookdetails;
const Nannycard = ({
  profileImage,
  firstName,
  lastName,
  price,
  address,
  date,
  time,
  counter,
  divs,
  latitude,
  longitude,
  categoryId,
  nannyId,
  categoriesDetail,
  basePrice,
  isSpecialDate,
  street,
  appartment,
  house,
  userAddress,
  avgRating,
  nammylatitude,
  nammylongitude,
  summary
}) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const navigateToAnotherScreen = () => {
    navigate("/bookdetails", {
      state: {
        address,
        date,
        time,
        counter,
        divs,
        latitude,
        longitude,
        categoryId,
        profileImage,
        price,
        firstName,
        lastName,
        nannyId,
        categoriesDetail,
        basePrice,
        isSpecialDate,
        street,
        appartment,
        house,
        userAddress,
        nammylatitude,
        nammylongitude,
        summary
      },
    });
  };

  const type = localStorage.getItem("type")
  const token = localStorage.getItem("Token")

  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div className="nanny_list_main px-3 text-center py-4 shadow bg-body">
        <div className="img_thumanail">
          <img
            src={profileImage !== "" ? profileImage : profile_icon}
            className="mb-3 profile-picture"
            style={profileImage === "" ? { 'width': '250px' } : {}}
            alt="Profile"
          />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <h3 style={{ margin: 0, cursor: "pointer", textDecoration: "underline" }} onClick={() => setIsOpen(true)}>
            {" "}
            <span>{firstName}</span> <span>{lastName}</span>
          </h3>
          <span className="star">
            <Star style={{ color: 'gold', fontSize: '20px' }} /> {avgRating}.0
          </span>
        </div>

        <ul>

          <li className="nany_small_details d-flex justify-content-between py-1">
            <h5>Address</h5>
            <h5>{address}</h5>
          </li>
        </ul>

        <div>
          {type != 1 &&
            <button
              className="btn btn-primary d-inline-block mt-2 all_btns px-4 py-2 position-relative"
              onClick={() => navigateToAnotherScreen(token != null ? "/nannycategories" : "/login")}
            >
              BOOK NANNY
            </button>
          }
        </div>
      </div>

      {/* <Modal show={isOpen} onHide={() => setIsOpen(false)} className="add_detalis" >
        <Modal.Header closeButton><Modal.Title>Nanny Profile</Modal.Title></Modal.Header>
        <div style={{ padding: 20 }}>
          {nannyId &&
            <NannyProfileDisplay nannyId={nannyId} />
          }
          <div style={{ textAlign: "center", zIndex: 9999 }}>
            <Button onClick={() => setIsOpen(false)}>OK</Button>
          </div>
        </div>
      </Modal> */}

      <Modal
        show={isOpen}
        onHide={() => setIsOpen(false)}
        className="add_details"
        centered
        size="lg"
        backdrop="static"
        keyboard={false}
        style={{ maxWidth: '100%', 'marginTop': '5vh' }}
      >
        {/* Modal Header */}
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "#f8f9fa",
            borderBottom: "1px solid #dee2e6",
          }}
        >
          <Modal.Title className="fw-bold text-primary">
            Nanny Profile
          </Modal.Title>
        </Modal.Header>

        {/* Modal Body */}
        <Modal.Body style={{
          maxHeight: '70vh',
          overflowY: 'auto',
          padding: '1.5rem',
          backgroundColor: "#ffffff",
        }}>
          {nannyId && <NannyProfileDisplay nannyId={nannyId} />}
        </Modal.Body>

        {/* Modal Footer */}
        <Modal.Footer
          style={{
            justifyContent: "center",
            padding: "1rem 1.5rem",
            backgroundColor: "#f8f9fa",
            borderTop: "1px solid #dee2e6",
          }}
        >
          <Button
            variant="primary"
            onClick={() => setIsOpen(false)}
            style={{
              width: "120px",
              fontWeight: "600",
              borderRadius: "8px",
              boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Nannycard;
